'use client';

import { forwardRef, ButtonHTMLAttributes } from 'react';
import styles from './NavArrow.module.css';
import Icon from './Icon';

interface NavArrowProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  direction: 'prev' | 'next';
  size?: 'sm' | 'md';
  /** Icon style: 'arrow' = full arrow (arrow_back/forward), 'chevron' = chevron (used by pagination) */
  variant?: 'arrow' | 'chevron';
}

const ICONS = {
  arrow: { prev: 'arrow_back', next: 'arrow_forward' },
  chevron: { prev: 'chevron_left', next: 'chevron_right' },
} as const;

const NavArrow = forwardRef<HTMLButtonElement, NavArrowProps>(({
  direction,
  size = 'md',
  variant = 'arrow',
  className = '',
  'aria-label': ariaLabel,
  ...props
}, ref) => {
  const defaultLabel = direction === 'prev' ? 'Previous' : 'Next';

  return (
    <button
      ref={ref}
      className={[styles.navArrow, styles[size], styles[direction], variant === 'arrow' ? styles.bare : '', className].filter(Boolean).join(' ')}
      type="button"
      aria-label={ariaLabel || defaultLabel}
      {...props}
    >
      <Icon name={ICONS[variant][direction]} size={size === "sm" ? 18 : 22} />
    </button>
  );
});

NavArrow.displayName = 'NavArrow';
export default NavArrow;
